import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import SubHeader from '../../components/SubHeader/SubHeader';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useDebouncedCallback } from 'use-debounce';
import Button from '../../components/Button/Button';
import UpcomingRacesHeader from '../UpcomingRacesView/UpcomingRacesHeader/UpcomingRacesHeader';
import { useAppSelector } from '../../store/reducers';
import { getRaces } from '../../store/reducers/Results/resultsSlice';
import { saveFilterData } from '../../store/reducers/Results/resultsSlice';
import RaceResultsList from './RaceResultsList/RaceResultsList';
import QuickRaceModal from '../../components/Modals/QuickRaceModal/QuickRaceModal';
import { quickRaces } from '../../store/selectors/upcomingRacesSelectors';
const ResultsView = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [params, setParams] = useSearchParams();
    const { filtersValue } = useAppSelector((state) => state.results);
    const quickRacesList = useSelector(quickRaces);
    const [filters, setFilters] = useState(true);
    const [myRaces, setMyRaces] = useState(true);
    const [paramLength, setParamLength] = useState(0);
    const [isVisibleQuickRaceVisible, setVisibleQuickRace] = useState(false);
    const handleSearchChange = useDebouncedCallback((value) => {
        params.set('name', value);
        setParams(params);
    }, 400);
    const renderButtons = () => {
        return (_jsx("div", Object.assign({ className: 'd-flex' }, { children: _jsx(Button, { color: 2, text: t('quick_race'), size: 'md', height: 'sm', onClick: () => setVisibleQuickRace(true) }) })));
    };
    useEffect(() => {
        dispatch(getRaces());
    }, [params]);
    useEffect(() => {
        if (filtersValue) {
            const params = Object.fromEntries(new URLSearchParams(filtersValue));
            setParamLength(Object.keys(params).length);
        }
    }, [filtersValue, paramLength]);
    useEffect(() => {
        return () => {
            dispatch(saveFilterData({}));
        };
    }, [dispatch]);
    return (_jsxs("div", { children: [_jsx(SubHeader, { title: t('results'), buttons: renderButtons() }), _jsx(UpcomingRacesHeader, { filters: filters, onFilterClick: () => setFilters(!filters), onChangeSearch: handleSearchChange, myRaces: myRaces, onMyRacesClick: () => setMyRaces(!myRaces) }), _jsx(RaceResultsList, { filters: filters }), isVisibleQuickRaceVisible && (_jsx(QuickRaceModal, { quickRaceList: quickRacesList, onClose: () => setVisibleQuickRace(false) }))] }));
};
export default ResultsView;
